import { TICKER_ITEMS } from "../lib/copy";

export default function Ticker({ items = TICKER_ITEMS }) {
  const seq = [...items, ...items];
  return (
    <section className="ticker-wrap" data-testid="proof-ticker">
      <div className="ticker-track">
        {seq.map((item, i) => (
          <span className="ticker-item" key={i}>
            {item}
            <span className="ticker-sep">◆</span>
          </span>
        ))}
      </div>
    </section>
  );
}
